import {
  Button,
  Flex,
  Radio,
  RadioProps,
  Text,
  useDisclosure
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { validationValue } from "@/utils/validationValue";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

interface PartnerProps extends RadioProps {
  name: string;
  image: string;
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  phone1: string;
  phone2: string;
  cellphone: string;
  runflat: boolean;
  blindado: boolean;
  priceCarMounting: string;
  priceCarAlignment: string;
  priceCarBalancing: string;
  priceCarValve: string;
  priceCarCaster: string;
  priceCarCamber: string;
  priceCarRunflat?: string;
  priceCarBlindado?: string;
  priceUtilityMounting: string;
  priceUtilityAlignment: string;
  priceUtilityBalancing: string;
  priceUtilityValve: string;
  priceUtilityCaster: string;
  priceUtilityCamber: string;
  priceUtilityRunflat?: string;
  priceUtilityBlindado?: string;
}

export function CardPartnersMob({
  name,
  image,
  street,
  number,
  district,
  city,
  state,
  phone1,
  phone2,
  cellphone,
  runflat,
  blindado,
  priceCarMounting,
  priceCarAlignment,
  priceCarBalancing,
  priceCarValve,
  priceCarCaster,
  priceCarCamber,
  priceCarRunflat,
  priceCarBlindado,
  priceUtilityMounting,
  priceUtilityAlignment,
  priceUtilityBalancing,
  priceUtilityValve,
  priceUtilityCaster,
  priceUtilityCamber,
  priceUtilityRunflat,
  priceUtilityBlindado,
  ...rest
}: PartnerProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [WW, setWW] = useState(Number);

  useEffect(() => {
    setWW(window.innerWidth);
  }, []);

  return (
    <Radio
      w="full"
      h="160px"
      {...rest}
      borderWidth="2px"
      borderColor="gray.300"
      borderStyle="solid"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        w="full"
        h="156px"
        position="relative"
        // borderTopWidth="2px"
        // borderTopColor="gray.300"
        // borderTopStyle="solid"
        // borderBottomWidth="2px"
        // borderBottomColor="gray.300"
        // borderBottomStyle="solid"
      >
        <Flex direction="column" w="300px">
          <Text textStyle="Bold">{name}</Text>
          <Text fontSize="text3" color="blue.900">
            3,2 Km distante do seu endereço
          </Text>
          <Text fontSize="text3">
            Rua {street}, {number}
            <br />
            {district} - {city} - {state}
          </Text>
          <Text fontSize="text3">
            {phone2
              ? cellphone
                ? `${phone1} - ${phone2} - ${cellphone}`
                : `${phone1} - ${phone2}`
              : phone1}
          </Text>
        </Flex>
        <Button
          justifySelf="flex-end"
          w="160px"
          borderRadius="0"
          transform="rotate(-90deg)"
          bgColor="green.900"
          color="white"
          textStyle="MRegular"
          fontSize="text3"
          position="absolute"
          right="-90px"
          px="5px"
          sx={{ ".arrowIcon": { ml: "5px" } }}
          _hover={{ bgColor: "green.900" }}
          onClick={onOpen}
        >
          PREÇOS
          <IoIosArrowDown
            className="arrowIcon"
            fontWeight="bold"
            color="#fff"
          />
        </Button>

        <Flex
          bgColor="white"
          w="320px"
          h="160px"
          position="absolute"
          right={isOpen ? "-20px" : "-370px"}
          transition="all ease .3s"
        >
          <Flex position="relative" alignItems="center" w="full" h="full">
            <Flex mr="10px" direction="column" alignItems="right" w="147px">
              <Text fontSize="text4" textStyle="Bold">
                Serviços / Peças
              </Text>
              <Text fontSize="text4">Montagem (por roda)</Text>
              <Text fontSize="text4">Alinhamento</Text>
              <Text fontSize="text4">Balaceamento (por roda)</Text>
              <Text fontSize="text4">Válvula (unidade)</Text>
              <Text fontSize="text4">Cáster</Text>
              <Text fontSize="text4">Cabagem</Text>
              {runflat && (
                <Text fontSize="text4">Montagem (por roda) Runflat</Text>
              )}
              {blindado && (
                <Text fontSize="text4">Montagem (por roda) Blindado</Text>
              )}
            </Flex>
            <Flex direction="column" mr="10px">
              <Text fontSize="text4" textStyle="Bold">
                Carro
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceCarMounting) && "blue.900"}
              >
                {priceCarMounting}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceCarAlignment) && "blue.900"}
              >
                {priceCarAlignment}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceCarBalancing) && "blue.900"}
              >
                {priceCarBalancing}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceCarValve) && "blue.900"}
              >
                {priceCarValve}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceCarCaster) && "blue.900"}
              >
                {priceCarCaster}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceCarCamber) && "blue.900"}
              >
                {priceCarCamber}
              </Text>
              {runflat && (
                <Text
                  fontSize="text4"
                  color={validationValue(priceCarRunflat) && "blue.900"}
                >
                  {priceCarRunflat}
                </Text>
              )}
              {blindado && (
                <Text
                  fontSize="text4"
                  color={validationValue(priceCarBlindado) && "blue.900"}
                >
                  {priceCarBlindado}
                </Text>
              )}
            </Flex>
            <Flex direction="column">
              <Text fontSize="text4" textStyle="Bold">
                Utilítario
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceUtilityMounting) && "blue.900"}
              >
                {priceUtilityMounting}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceUtilityAlignment) && "blue.900"}
              >
                {priceUtilityAlignment}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceUtilityBalancing) && "blue.900"}
              >
                {priceUtilityBalancing}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceUtilityValve) && "blue.900"}
              >
                {priceUtilityValve}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceUtilityCaster) && "blue.900"}
              >
                {priceUtilityCaster}
              </Text>
              <Text
                fontSize="text4"
                color={validationValue(priceUtilityCamber) && "blue.900"}
              >
                {priceUtilityCamber}
              </Text>
              {runflat && (
                <Text
                  fontSize="text4"
                  color={validationValue(priceUtilityRunflat) && "blue.900"}
                >
                  {priceUtilityRunflat}
                </Text>
              )}
              {blindado && (
                <Text
                  fontSize="text4"
                  color={validationValue(priceUtilityBlindado) && "blue.900"}
                >
                  {priceUtilityBlindado}
                </Text>
              )}
            </Flex>
            <Button
              justifySelf="flex-end"
              w="160px"
              borderRadius="0"
              transform="rotate(-90deg)"
              bgColor="gray.300"
              color="white"
              textStyle="MRegular"
              fontSize="text3"
              position="absolute"
              right="-70px"
              px="5px"
              sx={{ ".arrowIcon": { ml: "5px" } }}
              _hover={{ bgColor: "green.900" }}
              onClick={onClose}
            >
              PREÇOS
              <IoIosArrowUp
                className="arrowIcon"
                fontWeight="bold"
                color="#fff"
              />
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Radio>
  );
}
